/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */
import en_US from './lang/en_US';
import zh_CN from './lang/zh_CN';
import { register } from './register';
register('en_US', en_US);
register('zh_CN', zh_CN);
export { format } from './format';
export { render, cancel } from './realtime';
export { register };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/timeago.js/esm/index.js
// module id = 2156
// module chunks = 2